import { FormControl, FormGroup } from '@angular/forms';
import { CampaignFieldTypeEnum } from '@www/_models';

export function setCampaignFormErrors(
  errorsObj: {
    [key: string]: {
      children: {
        field: any;
        value: {
          errors?: string[];
        };
      };
    };
  },
  form: FormGroup<{
    [identifier: string]: FormGroup<{
      type: FormControl<CampaignFieldTypeEnum | null>;
      value: FormControl<any>;
      otherValue?: FormControl<string | null>;
    }>;
  }>,
): void {
  console.warn('setCampaignFormErrors errors', errorsObj);
  for (const key in errorsObj) {
    if (!Object.prototype.hasOwnProperty.call(errorsObj, key)) {
      continue;
    }
    console.warn('setCampaignFormErrors key', key);

    // set errors to form controls
    const fieldErrors = errorsObj[key]?.children?.value?.errors;
    if (fieldErrors && fieldErrors.length > 0 && form.controls[key]) {
      const fieldGroup = form.controls[key];

      // If the field group exists, set errors on the value control
      if (fieldGroup && fieldGroup.controls.value) {
        fieldGroup.controls.value.setErrors({
          backend: fieldErrors[0],
        });
        fieldGroup.controls.value.markAsTouched();
      }
    }
  }
}
